module.exports = __webpack_public_path__ + "img/idselfie.feae6837.png";